import React from 'react';
import PHPURL from './ReducerPHPURL';
import AccountCircle from '@material-ui/icons/AccountCircle';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Announcement from '@material-ui/icons/Announcement';
import Computer from '@material-ui/icons/Computer';
import TableHeader from './ReducerTableHeader';
import FormLabels from './ReducerFormLabels';
import BarChart from '@material-ui/icons/BarChart';

export default function() {
    return [
        {
            'id': 1,
            'defaultName': 'USERS',
            'role': ['recruiter', 'admin'],
            'icon': <AccountCircle />,
            'subitems': [
                {
                    'id':1.1,
                    'defaultName': 'CANDIDATES',
                    'role': ['recruiter', 'admin'],
                    'phpURL': PHPURL.baseURL + PHPURL.getData + 'Candidati',
                    'phpSubtype': null,
                    'insertTable': 'Voluntari',
                    'updateTable': 'Candidati',
                    'hideAddButton': true,
                    'viewType': 'TableBuilderWithForm',
                    'tableHeader': TableHeader.Candidates,
                    'formLabels': FormLabels.Volunteers,
                    'formOptions': PHPURL.baseURL + PHPURL.getOptions,
                    'subTableHeader': null,
                    'subFormLabels': null,
                    'subFormInsert':  null
                },
                {
                    'id':1.2,
                    'defaultName': 'VOLUNTEERS',
                    'role': ['recruiter', 'admin'],
                    'phpURL': PHPURL.baseURL + PHPURL.getData + 'Voluntari',
                    'phpSubtype': PHPURL.baseURL + PHPURL.getActivitiesForVolunteer,
                    'insertTable': null,
                    'updateTable': 'Voluntari',
                    'viewType': 'TableBuilder',
                    'tableHeader': TableHeader.Volunteers,
                    'formLabels': null,
                    'formOptions': null,
                    'subTableHeader': TableHeader.ActivitiesForVolunteer,
                    'subFormLabels': null,
                    'subFormInsert':  null
                },
                {
                    'id':1.3,
                    'defaultName': 'ADMINS',
                    'role': ['admin'],
                    'phpURL': PHPURL.baseURL + PHPURL.getSpecialUsersList,
                    'phpSubtype': null,
                    'insertTable': 'Admini',
                    'updateTable': 'Admini',
                    'viewType': 'TableBuilderWithForm',
                    'tableHeader': TableHeader.Admini,
                    'formLabels': FormLabels.Admini,
                    'formOptions': PHPURL.baseURL + PHPURL.getOptions,
                    'subTableHeader': null,
                    'subFormLabels': null,
                    'subFormInsert':  null
                }
            ]
        },
        {
            'id': 2,
            'defaultName': 'ACTIVITIES',
            'role': ['coordinator', 'admin'],
            'icon': <CalendarToday />,
            'subitems': [
                {
                    'id':2.1,
                    'defaultName': 'PAST_ACTIVITIES',
                    'role': ['admin'],
                    'phpURL': PHPURL.baseURL + PHPURL.getActivitiesList + 'operator=<&closed=Da',
                    'phpSubtype': PHPURL.baseURL + PHPURL.getVolunteersAtActivity,
                    'insertTable': 'Participare',
                    'updateTable': 'Activitati',
                    'viewType': 'TableBuilder',
                    'tableHeader': TableHeader.PastActivities,
                    'formLabels': null,
                    'formOptions': PHPURL.baseURL + PHPURL.getOptions,
                    'subTableHeader': TableHeader.VolunteersAtPastActivity,
                    'subFormLabels': FormLabels.VolunteersAtActivity,
                    'subFormInsert':  PHPURL.baseURL + PHPURL.insertVolunteerAtActivity
                },
                {
                    'id':2.2,
                    'defaultName': 'FUTURE_ACTIVITIES',
                    'role': ['coordinator', 'admin'],
                    'phpURL': PHPURL.baseURL + PHPURL.getActivitiesList + 'operator=>&closed=Nu',
                    'phpSubtype': PHPURL.baseURL + PHPURL.getVolunteersAtActivity,
                    'insertTable': 'Activitati',
                    'updateTable': 'Activitati',
                    'viewType': 'TableBuilderWithForm',
                    'tableHeader': TableHeader.FutureActivities,
                    'formLabels': FormLabels.Activities,
                    'formOptions': null,
                    'subTableHeader': TableHeader.VolunteersAtFutureActivity,
                    'subFormLabels': null,
                    'subFormInsert':  null
                },
                {
                    'id':2.3,
                    'defaultName': 'VALIDATE_PRESENCE',
                    'role': ['coordinator', 'admin'],
                    'phpURL': PHPURL.baseURL + PHPURL.getActivitiesList + 'operator=<&closed=Nu',
                    'phpSubtype': PHPURL.baseURL + PHPURL.getVolunteersAtActivity,
                    'insertTable': 'Participare',
                    'updateTable': 'Participare',
                    'viewType': 'TableBuilder',
                    'tableHeader': TableHeader.ActivitiesToValidate,
                    'formLabels': null,
                    'formOptions': PHPURL.baseURL + PHPURL.getOptions,
                    'subTableHeader': TableHeader.ValidatePresence,
                    'subFormLabels': FormLabels.VolunteersAtActivity,
                    'subFormInsert':  PHPURL.baseURL + PHPURL.insertVolunteerAtActivity
                }
            ]
        },
        {
            'id': 3,
            'defaultName': 'ANNOUNCEMENTS',
            'role': ['admin'],
            'icon': <Announcement />,
            'phpURL': PHPURL.baseURL + PHPURL.getData + 'Anunturi',
            'phpSubtype': null,
            'insertTable': 'Anunturi',
            'updateTable': 'Anunturi',
            'viewType': 'TableBuilderWithForm',
            'tableHeader': TableHeader.Announcements,
            'formLabels': FormLabels.Announcements,
            'formOptions': null,
            'subTableHeader': null,
            'subFormLabels': null,
            'subFormInsert':  null
        },
        {
            'id': 4,
            'defaultName': 'COURSES',
            'role': ['admin'],
            'icon': <Computer />,
            'phpURL': PHPURL.baseURL + PHPURL.getData + 'Cursuri',
            'phpSubtype':  PHPURL.baseURL + PHPURL.getVolunteersAtCourse,
            'insertTable': 'Cursuri',
            'updateTable': 'Cursuri',
            'viewType': 'TableBuilderWithForm',
            'tableHeader': TableHeader.Courses,
            'formLabels': FormLabels.Courses,
            'formOptions': null,
            'subTableHeader': TableHeader.VolunteersAtCourse,
            'subFormLabels': null,
            'subFormInsert':  null
        },
        {
            'id': 5,
            'defaultName': 'REPORTS',
            'role': ['admin'],
            'icon': <BarChart />,
            'phpURL': PHPURL.baseURL + PHPURL.reportsDataGathering,
            'viewType': 'Reports'
        }
    ]
} 




// WEBPACK FOOTER //
// ./src/reducers/ReducerSidemenu.js